export default {
  suggestedLocations: [],
  searchLocations: []
};
